<template>
  <Popover v-model:open="show">
    <div class="space-y-2">
      <LabelComponent>{{ props.label }}</LabelComponent>
      <PopoverTrigger as-child>
        <Button class="w-full" variant="outline">
          {{ formattedDate }}
        </Button>
      </PopoverTrigger>
    </div>
    <PopoverContent class="w-auto">
      <Calendar v-model="date" :weekday-format="'short'" class="rounded-md" @update:modelValue="onDateChange" />
    </PopoverContent>
  </Popover>
</template>

<script setup lang="ts">
import { Button } from '@/components/ui/button';
import { Calendar } from '@/components/ui/calendar';
import { LabelComponent } from '@/components/ui/label';
import { Popover, PopoverContent, PopoverTrigger } from '@/components/ui/popover';
import { formatDateShort } from '@/utils/format.utils';
import { getLocalTimeZone, parseDate, today, type DateValue } from '@internationalized/date';
import { computed, ref, watch, type Ref } from 'vue';

const props = defineProps<{
  label: string;
  initialDate?: Date;
}>();

const emit = defineEmits(['update:date']);

const show = ref(false);
const formattedDate = computed(() =>
  date.value ? formatDateShort(new Date(date.value.toString())) : `Select ${props.label}`,
);
const date = ref(
  props.initialDate ? parseDate(props.initialDate.toISOString()) : today(getLocalTimeZone()),
) as Ref<DateValue>;

const onDateChange = () => {
  if (date.value) {
    emit('update:date', date.value.toString());
  }
};

watch(
  date,
  (newVal) => {
    if (newVal) emit('update:date', newVal?.toString());
    show.value = false;
  },
  { immediate: true },
);
</script>
